var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileCall = function SvgMobileCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mobile_call_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001731",
    stroke: "#171D38",
    strokeWidth: 0.971,
    d: "M12.5.985c6.349 0 11.515 5.167 11.515 11.515S18.849 24.015 12.5 24.015.985 18.849.985 12.5C.985 6.152 6.151.985 12.5.985Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m7.32 7.335-.004.004a1.8 1.8 0 0 0-.614 1.424c.043 2.337 1.21 4.62 2.91 6.32 1.7 1.702 3.983 2.872 6.326 2.916a1.8 1.8 0 0 0 1.425-.614l.003-.005 1.01-1.18c.243-.283.357-.653.318-1.023v-.001c-.04-.37-.231-.707-.528-.932l-1.814-1.377a1.193 1.193 0 0 0-1.635.184l-.854 1.02a.31.31 0 0 1-.35.085 5.8 5.8 0 0 1-1.694-1.25l-.011-.013-.013-.011a5.8 5.8 0 0 1-1.25-1.694.31.31 0 0 1 .086-.35l1.02-.854a1.193 1.193 0 0 0 .183-1.634l-1.377-1.815a1.352 1.352 0 0 0-1.957-.21z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mobile_call_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.5h24v24H.5z"
  })))));
};
export default SvgMobileCall;